enum PublicApi {
  FORGOT_PASSWORD = "public/participant/forgotPassword",
  CAPTCHA = `public/captcha/generate`,
  REG_DETAIL = `public/registration/findByRegistrationKeyOrId`,
  REGISTRATION_FORM = `public/participant/registration/findRegistrationForm`,
  INITIATE_REG = `public/participant/registration/initiate`,
  REGISTRATION_FORMS_LIST = `public/registration/findRegistrationFormsByRegistration`,
  LOGIN = `login`,
  LOGOUT = "logout",
  STATIC_DATA = "public/staticData/get",
  GET_SIDE_FILTER = "public/staticData/getUiFilters",
  FIND_ORGANIZATION_BY_NAME = `public/organization/findByName`,
  FIND_ORGANIZATION_DETAILS_FOR_REGISTRATION = `public/registrationOrganization/findProfileMap`,
  FIND_REGISTRATION_ORGANIZATION_BY_ORGANIZATION = "public/registrationOrganization/findByRegistrationIdAndOrganizationId",
  GET_IMAGE_BASE64 = `public/socialPost/getGcsImageBase64`,
  SOCIAL_MEDIA_UPLOAD = "public/registrationParticipant/socialPostTemplate/upload",
  GET_SIDE_FILTERS_WITH_COUNT = "public/programParticipant/consoleFilter/findByContextIdAndScreenType",
  GET_UTILITY_DATA_DETAIL = "public/registrationUtilityData/getUtilityDataByFeatureAndModuleAndContext",
  GET_SPONSOR_AD_BY_INVENTORY_SUB_TYPE_CONTEXT = "public/digitalSpaces/findBySubInventoryTypeForRegistration",
  GET_UTILITY_DATA_MODULES_LIST = "public/registrationUtilityData/getUtilityDataByRegistrationAndFeature",
  GET_UTILITY_DATA_MODULE_DETAILS = "public/registrationUtilityData/getUtilityDataByFeatureAndModuleAndContext",
  LOG_CONSENT = "public/gdprconsent/log",
  GET_CONSENT_COPY = "public/gdprconsent/copy",
  FIND_REGISTRATION_FORMS_BY_REGISTRATION_ID = "public/registration/config/findRegistrationFormsByRegistration",
  FIND_EVENT_ATTENDEE_REGISTRATION_FORMS_BY_REGISTRATION_ID = "public/registration/config/findEventAttendeeRegistrationFormsByRegistration",
  EVENT_AGENDA = "public/eventAgenda",
  SPONSOR_ORGANIZATIONS = "public/sponsorsAndExhibitor",
  CREATE_SCHEMA_FIELD_ASSET = "public/resourceAsset/create",
  EMAIL_DOMAIN_VALIDATION = "public/registration/validateWorkEmail",
  SPONSOR_AD_DATA_BY_INVENTORY_SUB_TYPE = "public/digitalSpaces/findByRegistrationIdAndInventorySubTypes"
}

export default PublicApi;
